import { lazy } from 'react';

const ErrorPageAsync = lazy(() => import('./ErrorPage'));

export default ErrorPageAsync;
